import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_7958778f-24e1-4f8a-8782-03ff5c0253be/artifacts/8cqxwjmz_STCU.png";

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
